import store from "../../../store/index";
import {
  getMyAccountsService,
  getAccountsNewsService,
  accountSearchService,
  addAccountService,
  getAccountsNewsFilterService,
} from "../../Services/AccountsService";
import { MY_ACCOUNTS, ACCOUNTS_NEWS, ACCOUNT_SEARCH, DRAG_DROP } from "../../../constants/actionTypes";
import { IArticlesItem } from "../interfaces";
import { searchAccountsSerialize, serializeAccounts, serializeNewsArticles, serializeNewsFilters } from "./utils";

export const getMyAccounts = () => {
  store.dispatch({ type: MY_ACCOUNTS.LOAD });
  //* for showing the loader in articles container asynchronously otherwise it was showing as synchronous
  store.dispatch({
    type: ACCOUNTS_NEWS.LOAD,
  });
  getMyAccountsService()
    .then((res) => {
      if (res.data) {
        store.dispatch({
          type: MY_ACCOUNTS.LOAD_SUCCESS,
          payload: serializeAccounts(res.data),
        });
        if (!res.data.length) {
          store.dispatch({ type: ACCOUNTS_NEWS.LOAD_FAIL });
        }
      }
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: MY_ACCOUNTS.LOAD_FAIL,
        payload: [],
      });
      store.dispatch({ type: ACCOUNTS_NEWS.LOAD_FAIL });
      // show error alert on frontend
    });
};

export const resetMyAccounts = () => {
  store.dispatch({
    type: MY_ACCOUNTS.RESET_ACOUNT,
  });
};

export const accountSearch = (keyword: string | string[]) => {
  store.dispatch({
    type: ACCOUNT_SEARCH.LOAD,
  });
  accountSearchService(keyword)
    .then((res) => {
      // console.log(res.data);
      let serializedSearchAccounts = searchAccountsSerialize(res.data);
      store.dispatch({
        type: ACCOUNT_SEARCH.LOAD_SUCCESS,
        payload: serializedSearchAccounts,
      });
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: ACCOUNT_SEARCH.LOAD_FAIL,
        payload: [],
      });
      // show error alert on frontend
    });
};

export const resetSearchAccounts = () => {
  store.dispatch({
    type: ACCOUNT_SEARCH.UPDATE_STATE,
    payload: [],
  });
  store.dispatch({
    type: DRAG_DROP.RESET_SELECTED_IDS,
  });
};

export const addAccount = (
  accountId: number,
  accountName: string,
  ticker: string,
  logo: string,
  accountPersonality?: string,
  accountPulse?: string
) => {
  store.dispatch({ type: ACCOUNT_SEARCH.ADD_LOAD, companyId: accountId });
  return addAccountService(accountId, accountName, ticker)
    .then((res: any) => {
      if (res.data.status && res.data.message !== "Unauthorized to add Company") {
        // resetMyAccounts();
        // for the case when user add it's first account after onboarding, to keep showing the header
        store.dispatch({
          type: MY_ACCOUNTS.ADD_NEW_ACCOUNT,
          new_account: {
            accountId: accountId,
            accountName: accountName,
            accountLogo: logo,
            state: "",
            accountPulse: accountPulse,
            accountPersonality: accountPersonality,
          },
        });
        store.dispatch({
          type: MY_ACCOUNTS.UPDATE_LENGTH,
        });
        return true;
      } else {
        return false;
      }
    })
    .catch((err: any) => {
      console.log(err);
      return false;
      // store.dispatch({
      //   type: ADD_ACCOUNT.FAIL,
      // });
      // show error alert on frontend
    });
};

export const getAccountsNews = (
  page = 0,
  accountIds: number[],
  filterIds?: number[],
  selectAll?: boolean,
  filter?: boolean
) => {
  if (filter === true) {
    store.dispatch({
      type: ACCOUNTS_NEWS.FILTER_MODE_ON,
    });
  } else {
    store.dispatch({
      type: ACCOUNTS_NEWS.LOAD,
    });
  }

  getAccountsNewsService(accountIds, page, filterIds, selectAll)
    .then((res) => {
      store.dispatch({
        type: ACCOUNTS_NEWS.LOAD_SUCCESS,
        articles: serializeNewsArticles(res.data),
      });
    })
    .catch((err) => {
      if (err.message && err.message.indexOf("Operation canceled") >= 0) {
        store.dispatch({
          type: ACCOUNTS_NEWS.FILTER_MODE_ON,
        });
      } else {
        console.log(err);
        store.dispatch({
          type: ACCOUNTS_NEWS.LOAD_FAIL,
          payload: Array<IArticlesItem>(),
        });
      }
      // show error alert on frontend
    });
};
export const getAccountNewsFilters = (callback: (() => void) | undefined = undefined) => {
  getAccountsNewsFilterService()
    .then((res) => {
      let serializedFilters = serializeNewsFilters(res.data);
      store.dispatch({
        type: ACCOUNTS_NEWS.LOAD_FILTERS_SUCCESS,
        filters: serializedFilters,
      });
      store.dispatch({
        type: MY_ACCOUNTS.UPDATE_FILTERS_STATE,
        selectedFilters: serializedFilters.map((item) => item.filterId),
        selectAll: true,
      });
      if (callback) {
        callback();
      }
    })
    .catch((err) => {
      if (err.message && err.message.indexOf("Operation canceled") >= 0) {
        store.dispatch({
          type: ACCOUNTS_NEWS.FILTER_MODE_ON,
        });
      } else {
        console.log(err);
      }
      // show error alert on frontend
    });
};

export const resetAccountsNews = () => {
  store.dispatch({ type: ACCOUNTS_NEWS.RESET });
};

export const resetAccountsNewsData = () => {
  store.dispatch({ type: ACCOUNTS_NEWS.RESET_DATA });
};

export const resetSelectedAccounts = () => {
  store.dispatch({ type: MY_ACCOUNTS.RESET_SELECTED_ACCOUNTS });
};

export const myAccountsSelectAllFilter = (flag: boolean) => {
  store.dispatch({
    type: MY_ACCOUNTS.SET_SELECT_ALL,
    selectAll: flag,
  });
};
